import { render, staticRenderFns } from "./ExplicitTopicRelatedTopicsWidget.vue?vue&type=template&id=7f89e155&scoped=true&"
import script from "./ExplicitTopicRelatedTopicsWidget.vue?vue&type=script&lang=js&"
export * from "./ExplicitTopicRelatedTopicsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ExplicitTopicRelatedTopicsWidget.vue?vue&type=style&index=0&id=7f89e155&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f89e155",
  null
  
)

/* custom blocks */
import block0 from "./ExplicitTopicRelatedTopicsWidget.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VCol,VContainer,VLazy,VRow,VSpacer})
